if (!customElements.get('custom-hotspot')) {
    class CustomHotSpot extends HTMLElement {
      constructor() {
        super();
        this.hotspot = this.querySelectorAll('.hotspot');
      }

        connectedCallback() {
            this.hotspot.forEach((element) => {
                element.addEventListener('click', () => {
                    const hotspottext = element.getAttribute('data-hotspot-text');
                    const mobileHotspotText = this.querySelector('.mobile_hotspot_text');
                    const backgroundHotspotText = this.querySelector('.background_hotspot_text');
                    if (hotspottext) {
                        mobileHotspotText.textContent = hotspottext;
                        backgroundHotspotText.textContent = hotspottext;
                    }
                    this.hotspot.forEach((el) => {
                        el.classList.remove('hotspot-active');
                    });
                    element.classList.add('hotspot-active');
                });
            });
        }
    }
    customElements.define('custom-hotspot', CustomHotSpot);
}